module.exports = __webpack_public_path__ + "static/bg_mobile-26aebbd391c2998f57de12ccd8622429.png";